var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20_\u4E2A\u4EBA\u4E2D\u5FC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,60H14a3.79,3.79,0,0,1-.67-.06,3.61,3.61,0,0,1-2.76-2.25A3.87,3.87,0,0,1,11,53.93l7.79-10.39a22,22,0,1,1,26.36,0l7.74,10.38a3.9,3.9,0,0,1,.49,3.76A3.71,3.71,0,0,1,50,60Zm-.25-3.67h0ZM14.46,56h35L41.94,46a3.92,3.92,0,0,1-.75-3,4,4,0,0,1,1.58-2.61A18,18,0,0,0,31,8a18,18,0,0,0-9.83,32.34A4,4,0,0,1,22,45.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,33.05a6.16,6.16,0,0,1-6.15-6.15,2,2,0,0,1,4,0,2.15,2.15,0,0,0,4.3,0,2,2,0,0,1,4,0A6.16,6.16,0,0,1,32,33.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserhome);
export default __webpack_public_path__ + "static/media/userhome.b1350a70.svg";
export { ForwardRef as ReactComponent };